import { render, staticRenderFns } from "./ContentFeed.vue?vue&type=template&id=775fd9c1&scoped=true"
import script from "./ContentFeed.vue?vue&type=script&lang=js"
export * from "./ContentFeed.vue?vue&type=script&lang=js"
import style0 from "./ContentFeed.vue?vue&type=style&index=0&id=775fd9c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775fd9c1",
  null
  
)

export default component.exports